import { css } from '@emotion/core';
import styled from '@emotion/styled';
import KizenTypography from '@kizen/page-builder/internal/app/kizentypo';

const typeBackgrounds = {
  content:
    'color-mix(in srgb, var(--color-viz-cat-1-primary) 10%, transparent)',
  row: 'color-mix(in srgb, var(--color-viz-cat-3-primary) 10%, transparent)',
  section:
    'color-mix(in srgb, var(--color-viz-cat-2-primary) 10%, transparent)',
};

const textStyle = css`
  color: var(--color-font-primary);
  font-size: 14px;
  font-family: 'Proxima Nova', sans-serif;
`;

const StyledKizenTypography = styled(KizenTypography)`
  && {
    ${textStyle}

    u,
    strong {
      ${textStyle}
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  background: ${({ dropType }) => {
    const background =
      typeBackgrounds[dropType] || 'var(--color-background-default)';
    return css`var(--color-background-white) linear-gradient(to right, ${background}, ${background})`;
  }};
  border: 1px dotted var(--color-viz-cat-2-secondary);
  margin: ${({ dropType }) => (dropType === 'content' ? '5px' : '10px')};
  > span {
    text-align: center;
    margin: 5px;
  }
`;

export default function EmptyNode({ dropType, children, ...others }) {
  return (
    <Wrapper dropType={dropType} {...others}>
      <StyledKizenTypography as="span">{children}</StyledKizenTypography>
    </Wrapper>
  );
}

export const EmptyOutline = styled.div`
  display: flex;
  flex-direction: column;
`;
